const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Faites votre choix ici.",
  seeAll: "Voir tout",
  clear: "Supprimer",
  back: "Retour",
  save: "Enregistrer",
  close: "Fermer",
  of: "De",
  to: "à",
  copyrights: "© {date} Bridgestone Solutions. Tous droits réservés.",
  pageNotFound: "Page non trouvée",
  accessDenied: "Accès refusé",
  search: "Recherche",
  year: "Année",
  buttons: {
    showMore: "Afficher plus",
    showAll: "Tout afficher",
    loading: "Chargement...",
    export: "Exporter",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    next: "Continuer",
    back: "RETOUR",
    skip: "Sauter",
    send: "Envoyer",
    close: "Fermer",
    clear: "Supprimer",
    readNow: "Lire maintenant",
    pointsList: "Accéder au relevé de compte",
    more: "Plus",
    reportError: "Signaler une erreur",
    accept: "Accepter",
    download: "Télécharger",
    downloadAll: "Tout télécharger",
    dealerInfoDownload: "Télécharger",
    toTheBasket: "Ajouter au panier",
    toOrderDelivery: "Continuer vers l'adresse de livraison",
    discover: "Découvrir",
    newAddress: "Créer une nouvelle adresse de livraison",
    selectAddressBtn: "Sélectionner l'adresse de livraison",
    toOrderSummary: "Vers le récapitulatif de la commande",
    placeOrder: "Commander (engagement)",
    toDashboard: "Vers la page d'accueil",
    newOrder: "Nouvelle commande",
    userOrders: "À vos ordres",
    toSearch: "Rechercher",
    select: "Sélectionner",
    moreCustomerNumbers: "+ AJOUTER PLUS DE NUMÉROS DE CLIENT",
    loadMore: "Charger plus",
    toStaffDashboard: "Accéder à Tableau de bord du personnel",
    toQuiz: "Vers le quiz",
    vouchers: "Bons d'achat",
    exchangeVoucher: "Utiliser le code du bon d'achat",
    confirm: "Confirmer",
    sharePoints: "Partager des points",
    downloadSelection: "Télécharger la sélection",
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner",
    setFilters: "Veuillez définir <b>au maximum un filtre par colonne</b>",
    clearFilters: "Réinitialiser le filtres",
    create: "Créer",
    update: "Mise à jour",
    toBDrive: "ACCÉDER À B-DRIVE",
    preview: "Aperçu",
    toDiscover: "Découvrir",
    clickHere: "Voir les détails",
    all: "Tous",
  },
  tooltips: {
    info: "",
  },
  confirmation: {
    header: "Confirmation requise",
    message: "Voulez-vous supprimer cet enregistrement ?",
  },
  nav: {
    consents: "Consentements",
    dashboard: "Page principale",
    accountDashboard: "Tableau de bord",
    account: "Mon compte",
    mailbox: "Boîte postale",
    singleMailbox: "Boîte postale",
    stammdaten: "Données de référence",
    news_feeds: "Actualités",
    pointsOverview: "Aperçu des points",
    rewardsOverview: "Aperçu des points",
    about: "À propos de BS Plus",
    service_number: "Service de contact",
    shop: "Votre Boutique Bridgestone",
    salesPromotions: "Promotions de vente",
    shopCategory: "Boutique de récompenses",
    productDetails: "Détails du produit",
    userOrders: "Commandes de l'utilisateur",
    shoppingCart: "Panier",
    orderDelivery: "Adresse de livraison",
    orderSummary: "Récapitulatif de la commande",
    orderComplete: "Commande terminée",
    text_page: "Page statique",
    promotions: "Mon compte",
    staff: "Tableau de bord des commerciaux",
    onlineTrainings: "Formations en ligne",
    trainings: "Formations",
    training: "Formation",
    trainingForm: "Formulaire de formation",
    staffVouchers: "Bons d'achat",
    wholesalerVouchers: "Bons d'achat",
    booster_ccs_form: "Booster CCS",
    share_points: "Partager des points",
    onlineTrainingCategory: "Formations en ligne",
    onlineTrainingCategoryType: "Formations en ligne",
    brochure_prices: "Brochures produits et listes de prix",
    investment: "Soutien aux investissements",
    media: "Médiathèque",
    medias: "Médiathèque",
    wholesaler: "Tableau de bord",
    contact_service: "Contact et Service",
    bridgestone_contact: "ASSISTANCE BRIDGESTONE PLUS",
    dekouple_contact: "ASSISTANCE BOUTIQUE",
    premium_partner_contact: "ASSISTANCE PARTENAIRES PREMIUM",
    productInfo: "Informations sur les produits",
    preislisten: "Listes de prixoduit",
    preislistenList: "Listes de prix",
    pricat: "Pricat",
    bDrive: "Images de produits",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Conditions de participation",
    first_stop: "Garantie pneus Bridgestone",
    payouts: "Payouts",
  },
  breadcrumbs: {
    dashboard: "Page principale",
    accountDashboard: "Tableau de bord",
    account: "Mon compte",
    mailbox: "Boîte postale",
    singleMailbox: "Ma boîte aux lettres",
    stammdaten: "Données de référence",
    news_feeds: "Actualités",
    pointsOverview: "Aperçu des points",
    rewardsOverview: "Aperçu des points",
    about: "À propos de BS Plus",
    service_number: "Service de contact",
    shop: "Votre Boutique Bridgestone",
    salesPromotions: "Promotions de vente",
    shopCategory: "Boutique de récompenses",
    productDetails: "Détails du produit",
    userOrders: "Commandes de l'utilisateur",
    shoppingCart: "Panier",
    orderDelivery: "Adresse de livraison",
    orderSummary: "Récapitulatif de la commande",
    orderComplete: "Commande terminée",
    promotions: "Mon compte",
    staff: "Tableau de bord des commerciaux",
    onlineTrainings: "Formations en ligne",
    trainings: "Formations",
    training: "Formation",
    trainingForm: "Formulaire de formation",
    staffVouchers: "Bons d'achat",
    wholesalerVouchers: "Bons d'achat",
    booster_ccs_form: "Booster CCS",
    share_points: "Partager des points",
    onlineTrainingCategory: "Formations en ligne",
    onlineTrainingCategoryType: "Formations en ligne",
    brochure_prices: "Brochures produits et listes de prix",
    investment: "Soutien aux investissements",
    media: "Médiathèque",
    medias: "Médiathèque",
    wholesaler: "Tableau de bord",
    contact_service: "Contact et Service",
    bridgestone_contact: "ASSISTANCE BRIDGESTONE PLUS",
    dekouple_contact: "ASSISTANCE BOUTIQUE",
    premium_partner_contact: "ASSISTANCE PARTENAIRES PREMIUM",
    productInfo: "INFORMATION PRODUIT",
    preislisten: "Listes de prixoduit",
    preislistenList: "Listes de prix",
    pricat: "Pricat",
    bDrive: "Images de produits",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Conditions de participation",
    first_stop: "Garantie pneus Bridgestone",
    payouts: "Payouts",
  },
  menu: {
    account: "Mon compte",
    plus: 'À propos de Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Soutien à la vente",
    mailbox: "Ma boîte aux lettres",
    about: 'À propos de Bridgestone <span class="text-danger">Plus</span>',
    trainingAndCourses: "Formations et cours",
    externalTraining: "Formations externes",
    productInfo: "Informations sur les produits",
    productBrochures: "Brochures sur les produits",
    priceLists: "Listes de prix",
    price: "Pricat",
    complaintForm: "Formulaire de réclamation",
    sales_support: "Soutien à la vente",
    contact_service: "Contact et Service",
    logOut: "Se déconnecter",
    news: "Actualités",
    news_feeds: "Actualités",
    service_number: "Contact et service",
    salesPromotions: "Promotions de vente",
    shop: "Boutique",
    onlineTrainings: "Formations en ligne",
    trainings: "Formations",
    brochure_prices: "Brochures produits",
    media: "MÉDIATHÈQUE",
    medias: "MÉDIATHÈQUE",
    preislisten: "Listes de prix",
    stammdaten: "Données de référence",
  },
  validation: {
    requiredField: "Champs obligatoires",
  },
  sortBy: {
    default: "Trier par",
    desc: "Trier par : Le plus récent",
    asc: "Trier par : Le plus ancien",
    name: "Nom",
    date: "Date",
    choiceBy: "Trier",
  },
  month: {
    1: "janvier",
    2: "février",
    3: "mars",
    4: "avril",
    5: "mai",
    6: "juin",
    7: "juillet",
    8: "août",
    9: "septembre",
    10: "octobre",
    11: "novembre",
    12: "décembre",
  },
};

export default {
  messages,
};
